module.exports = "<sq-load-error></sq-load-error>\n";